module.exports = __webpack_public_path__ + "media/vraag_7_vraag.454400fb.mp3";